import {
  FETCH_PRODUCT,
  FETCH_PRODUCT_SUCCESS,
  FETCH_PRODUCT_FAILURE,
  FILTER_PRODUCT
} from "./productsAction";

const initialState = {
  items: [],
  allItems: [],
  isFetching: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_PRODUCT:
      return {
        ...state,
        items: [],
        allItems: [],
        isFetching: true
      };
    case FETCH_PRODUCT_SUCCESS:
      return {
        ...state,
        items: action.payload,
        allItems: action.payload,
        isFetching: false
      };
    case FETCH_PRODUCT_FAILURE:
      return {
        ...state,
        items: [],
        allItems: [],
        isFetching: false
      };
    case FILTER_PRODUCT:
      let items = state.allItems;
      if (action.payload.length > 0) {
        items = state.allItems.filter(val =>
          action.payload.includes(val.brand)
        );
      }
      return {
        ...state,
        items: items,
        isFetching: false
      };
    default:
      return state;
  }
}
